export const SET_PLAYER_CONTENT_DATA = 'SET_PLAYER_CONTENT_DATA';

export const setPlayerContentData = () => ({type: SET_PLAYER_CONTENT_DATA });



// WEBPACK FOOTER //
// ./src/actions/playerContentData.js